<template>
    <div class="page home-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <div>
                <!-- <v-card flat class="bordered mb-4">
                    <v-card-title>
                        <v-icon>mdi-settings</v-icon>
                        <span>اﻹعدادات</span>
                    </v-card-title>
                </v-card> -->

                <v-card flat class="bordered" :class="{'px-5 py-1': pcOnly}">
                    <v-card-title>إعدادات اﻷمان</v-card-title>
                    <v-card-subtitle class="details-text grey--text pa-0 ms-4">إعدادات اﻷمان والحماية الخاصة بحسابك</v-card-subtitle>
                    <v-divider class="mt-4 mx-4" />

                    <v-list color="surface">
                        <v-list-item @click="passwordDialog = true">
                            <v-list-item-icon>
                                <v-icon color="strong-text">mdi-lock</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-subtitle>كلمة المرور</v-list-item-subtitle>
                                <v-list-item-title>**********</v-list-item-title>
                            </v-list-item-content>

                            <v-list-item-icon class="mx-4">
                                <v-icon color="grey lighten-1" size="21">mdi-pencil</v-icon>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </v-card>

                <v-dialog v-model="passwordDialog" persistent max-width="350" overlay-color="#000" overlay-opacity="0.7">
                    <v-card class="px-2 pb-1">
                        <v-card-title >تعديل كلمة المرور</v-card-title>
                        <!-- <v-card-subtitle>تغيير كلمة المرور الخاصة بحسابك</v-card-subtitle> -->
                        <v-card-text>
                            <v-text-field label="كلمة المرور الجديدة" :disabled="editing" type="password" v-model="password"></v-text-field>
                            <v-text-field hide-details label="تأكيد كلمة المرور الجديدة" :disabled="editing" type="password" v-model="confirmPassword"></v-text-field>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="grey darken-1" text @click="passwordDialog = false">إخفاء</v-btn>
                            <v-btn class="px-3" color="primary darken-1" :loading="editing" :disabled="editing" text @click="changePassword">تأكيد</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
      </v-container>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import SettingsItem from '@/components/default/settings-item'


export default {
    name: "Settings",
    components: {
        SettingsItem,
    },
    data(){
        return {
            passwordDialog: false,
            editing: false,
            password: '',
            confirmPassword: '',
            
        }
    },
    computed: {
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods,

        changePassword(){
            this.editing = true;
            const password = this.password,
                confirm = this.confirmPassword;
            if (password){
                if(password === confirm){
                    this.$store.dispatch('changePassword', {password}).then(()=>{
                        this.showMsg("تم تغيير كلمة السر بنجاح", 'success');
                        this.editing = false;
                        this.password = '';
                        this.confirmPassword = '';
                        this.passwordDialog = false;


                    }).catch((e)=>{
                        if (e.response && e.response.data === 'OLD_PASSWORD_WRONG'){
                            this.showMsg('كلمة السر القديمة غير صحيحة');
                        }else{
                            this.showMsg('حدثت مشكلة أثناء تنفيذ اﻹجراء');
                        }
                        this.editing = false;
                    })

                }else{
                    this.showMsg('كلمتا السر غير متطابقتين');
                    this.editing = false;
                }

            }else{
                this.showMsg('لا تترك حقلاً فارغاً');
                this.editing = false;
                this.passwordDialog = false;
            }
        },
    }
};
</script>
